import type { Signup } from "../../api";
import type { BadgeTone } from "../../components";

/** Le ton du badge par statut de demande : ce qui attend est en avertissement. */
export const TON_STATUT: Record<Signup["status"], BadgeTone> = {
  pending: "warning",
  accepted: "success",
  rejected: "danger",
};
